<template>
    <div id="table" class="w-100 h-100 d-flex flex-column">
        <layout-configuration-title v-if="filterable && filterSwitchAble && !filterSwitchInHeader"
                                    identify-code="mini-table-dropdown-filter"
                                    :key-code="entityTableKey"
                                    @loadConfig="unpackConfig"></layout-configuration-title>
        <div class="d-flex flex-row mb-1" v-if="!disableHeader">
            <b-button-group>
                <template v-if="!readOnly">
                    <em-button type="add" class="btn btn-outline-primary btn-sm"
                               @click="doAddOperation"></em-button>
                    <em-button v-if="!hasFieldEdit" type="edit" class="btn btn-outline-primary btn-sm"
                               :disabled="!isSelectOne"
                               @click="editRow"></em-button>
                    <em-button type="delete" class="btn btn-outline-primary btn-sm" :disabled="isSelectNone"
                               @click="deleteRow"></em-button>
                </template>
                <template v-if="enableInlineEdit">
                    <mini-button name="add" @btnClick="addInlineNewRow">
                        <i class="fa-solid fa-plus"></i>
                    </mini-button>
                </template>
                <slot name="leftHeader"></slot>
            </b-button-group>
            <layout-configuration-title v-if="filterable && filterSwitchAble && filterSwitchInHeader"
                                        identify-code="mini-table-dropdown-filter"
                                        :key-code="entityTableKey"
                                        @loadConfig="unpackConfig"></layout-configuration-title>
            <div class="d-flex flex-row flex-grow-1">
                <slot name="header"></slot>
            </div>
            <b-button-group class="ml-auto">
                <slot name="rightHeader"></slot>
                <customize-fields-with-btn v-if="showCustomizeFieldButton"
                                           :collection="modelGridFields"
                                           :localstorage-key="customizedFieldLocalstorageKey"
                                           @change="initData"></customize-fields-with-btn>
                <b-button v-if="enableChartGenerator" variant="outline-primary" @click="openTableChart()">
                    <i class="fa-solid fa-chart-line"></i>
                </b-button>
            </b-button-group>
            <wheel-number v-if="tableTreeValid && !expendAll && this.rowList.length > 0"
                          title="Tree Level"
                          :value.sync="expendDepth"
                          :min="0" :max="maxDepth"></wheel-number>
        </div>
        <div class="flex-grow-1 w-100 overflow-auto">
            <b-table ref="miniTable"
                     sticky-header
                     striped
                     hover
                     class="table-cover"
                     :selectable="!readOnly"
                     head-variant="light"
                     @row-selected="onRowSelected"
                     @row-clicked="whenRowClick"
                     :busy="tableLoading"
                     :items="limitRows"
                     :fields="fieldList"
                     no-local-sorting
                     @sort-changed="sortRows">
                <template #head(_row_check)>
                    <b-form-checkbox :checked="isSelectAll"
                                     @change="handleCheckAllEvent"/>
                </template>
                <template #head(_index)="{label}">
                    <div @click="toggleSelect">
                        <div class="badge" :class="isSelectNone?'':(isSelectAll?'badge-success':'badge-warning')">
                            {{ label }}
                        </div>
                        <template v-if="headerTitle != null">
                            {{ headerTitle }}
                        </template>
                        <template v-else>
                            共 {{ finalRowList.length }} 条记录
                        </template>
                    </div>
                </template>
                <template #head()="{label, field, column}">
                    <div class="d-flex flex-row"
                         :class="isActionColumn(column)?'action-column-header':''"
                         @dblclick="whenHeadDbClick(column)">
                        {{ $t(label) }}
                        <slot :name="`headAddition(${column})`"></slot>
                        <template v-if="openSortFilter.has(column)">
                            <div class="ml-auto">
                                <SortFilterDropdown
                                    :ref="'RFD_'+column"
                                    class="ml-1 mr-2"
                                    :label="$t(label)"
                                    :rows="finalRowList"
                                    :field-key="column"
                                    :sort-by="sortBy"
                                    :sort-desc="sortDesc"
                                    :keep-catch="lastFilterKey===column"
                                    :grouping-by="groupingField"
                                    @dateGroup="whenGrouping(column,$event)"
                                    @sortChange="setSorting"
                                    @filterChange="addToFilter(column,$event)"
                                    @checkedChange="addToCheckedFilter(column,$event)"
                                    @noFilter="removeFilter(column)"
                                    @clear="clearColFilter(column)"/>
                            </div>
                        </template>
                    </div>
                </template>

                <template #cell(_row_check)="data">
                    <b-form-checkbox :checked="checkedIds.has(data.item[rowKey])"
                                     @change="handleRowCheckEvent(data.item, $event)">
                    </b-form-checkbox>
                </template>
                <template #cell(_index)="data">
                    <div :class="data.rowSelected ? 'badge badge-success' : ''">{{ data.value }}</div>
                </template>
                <template #cell(__headOfRowSlot)="data">
                    <slot v-if="!isGroupRow(data)" name="headOfRow" :row="data.item"></slot>
                </template>
                <template #cell(__endOfRowSlot)="data">
                    <template>
                        <b-button-group>
                            <template v-if="enableInlineEdit && data.item[rowKey]">
                                <mini-button v-if="data.item.__rowEditing"
                                             @btnClick="cancelEditInlineRow(data.item._index-1)">
                                    <i class="fa-solid fa-xmark"></i>
                                </mini-button>
                                <mini-button v-else @btnClick="editInlineRow(data.item._index-1)">
                                    <i class="fa-solid fa-pen-to-square"></i>
                                </mini-button>
                            </template>
                            <delete-button
                                v-if="enableInlineEdit || inlineDeleteBtnUsed(data.item)"
                                variant="outline-primary" no-confirm
                                @btnClick="removeRow(data.item._index)"></delete-button>
                        </b-button-group>
                    </template>
                    <slot v-if="!isGroupRow(data)" name="endOfRow" :row="data.item"></slot>
                </template>
                <template #table-busy>
                    <div class="text-center text-danger my-2 position-sticky m-lr-auto" style="width: min-content;">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
                <template #cell()="data">
                    <div class="d-flex align-content-center" :class="data.field.flexColumn?'flex-column':'flex-row'">
                        <template v-if="isGroupRow(data)">
                            <div class="font-weight-bold">
                                {{ cellText(data) }}
                                <i v-if="groupingField === data.field.key" class="fa-solid fa-caret-down ml-1"></i>
                            </div>
                        </template>
                        <template v-else-if="isCustomColumn(data)">
                            <slot :name="customSlotName(data)" :row="data.item" :index="data.index"
                                  :val="data.item[data.field.key]"></slot>
                        </template>
                        <template v-else>
                            <template v-if="tableTreeValid && !isSorting && data.field.key === tableTreeNodeName">
                                <div :style="tableTreeNodeWidthOffset(data.item)"></div>
                                <div style="width: 1rem" class="mr-1">
                                    <div v-if="treeNodeHasChild(data.item)"
                                         @click="triggerRowExpend(data.item)">
                                        <b-button v-if="expendedTreeNode.has(getRowTreeNodeId(data.item))"
                                                  class="p-0 w-100"
                                                  variant="light">
                                            <i class="fa-solid fa-caret-down"></i>
                                        </b-button>
                                        <b-button v-else class="p-0 w-100" variant="light">
                                            <i class="fa-solid fa-caret-right"></i>
                                        </b-button>
                                    </div>
                                </div>
                                <b-form-checkbox v-if="enableTreeCheck"
                                                 v-model="nodeCheckStatus[getRowTreeNodeId(data.item)]"
                                                 @change="handleTreeCheckEvent($event,data.item)">
                                </b-form-checkbox>
                            </template>
                            <template v-if="isAdditionColumn(data) && isAdditionFront(data)">
                                <slot :name="additionSlotName(data)" :row="data.item" :index="data.index"
                                      :val="data.item[data.field.key]"></slot>
                            </template>

                            <template v-if="fieldIsEdit(data)">
                                <diverse-input :id="getDIRef(data)+'_id_'+data.item._index" :ref="getDIRef(data)"
                                               class="mini-table-di-input-cover"
                                               :value.sync="finalRowList[data.index][data.field.key]"
                                               :config="getDiverseInputConfig(data)"
                                               without-label delay-update
                                               :current-row="data.item"
                                               @focus="whenInputFocus(data)"
                                               @change="whenEditValueChange(data, $event)"></diverse-input>
                            </template>
                            <template v-else>
                                <template v-if="isFiledEditView(data)">
                                    <diverse-input class="w-100"
                                                   :value="finalRowList[data.index][data.field.key]"
                                                   :config="getDiverseInputConfig(data)"
                                                   without-label
                                                   disabled></diverse-input>
                                </template>
                                <template v-else-if="data.field.type === 'image' && data.value">
                                    <div class="w-100 overflow-auto d-flex flex-row">
                                        <b-img v-for="id of data.value.split(',')" :key="id"
                                               :src="_generateDownloadUrl(id)"
                                               fluid class="mb-1 mr-1"
                                               style="max-height: 100px"
                                               @click="$refs.viewImg.view(id, data.value.split(','))">
                                        </b-img>
                                    </div>
                                </template>
                                <template v-else-if="fieldIsLink(data.field)">
                                    <b-link @click="whenLinkClick(data)">
                                        {{ cellText(data) }}
                                    </b-link>
                                </template>
                                <template v-else>
                                    <ellipsis-text :text="cellText(data)"/>
                                </template>
                            </template>

                            <template v-if="isAdditionColumn(data) && !isAdditionFront(data)">
                                <slot :name="additionSlotName(data)" :row="data.item" :index="data.index"
                                      :val="data.item[data.field.key]"></slot>
                            </template>
                        </template>
                    </div>
                </template>
            </b-table>
            <empty-list-info v-if="showEmptyInfo"></empty-list-info>
        </div>

        <div v-if="enablePagination || autoPageView" class="w-100 d-flex flex-row mt-1">
            <b-form-select class="per-page-select-width" :options="perPageSelect" v-model="perPage"></b-form-select>
            <b-overlay :show="totalLoading" spinner-small spinner-variant="secondary">
                <b-pagination class="m-0"
                              v-model="currentPage"
                              :per-page="perPage" :total-rows="totalRows" align="right"
                              @change="whenPageChange"></b-pagination>
            </b-overlay>
        </div>

        <ReBModal header="新增" ref="rowFormModal" @ok="submitForm">
            <div class="d-flex flex-column">
                <diverse-input-group :configs="inputConfigList"
                                     ref="inputGroup"></diverse-input-group>
            </div>
        </ReBModal>

        <ReBModal ref="tableChartConfigureModal" v-if="enableChartGenerator"
                  centered clean disable-scrollable max-height max-width>
            <table-chart-configure ref="tableChartConfigure" large></table-chart-configure>
        </ReBModal>

        <view-images ref="viewImg"></view-images>
    </div>
</template>

<script>
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import EmptyListInfo from "@/components/echarts-part/CalendarShift/cells/stuffs/EmptyListInfo.vue";
import EmButton from "@/components/em/EmButton/index.vue";
import DiverseInputGroup from "@/components/workflow/stuffs/DiverseInputGroup.vue";
import DiverseInput from "@/components/workflow/stuffs/DiverseInput.vue";
import WheelNumber from "@/components/common/inputs/WheelNumber.vue";
import selfCrudMixin from "@/components/common/mini-table/mixins/self-crud-mixin";
import SortFilterDropdown from "@/components/common/mini-table/cells/SortFilterDropdown.vue";
import tableTreeMixin from "@/components/common/mini-table/mixins/table-tree-mixin";
import rowGroupMixin from "@/components/common/mini-table/mixins/row-group-mixin";
import TableChartConfigure from "@/components/echarts-part/TableChart/TableChartConfigure.vue";
import customDisplayMixin from "@/components/common/mini-table/mixins/custom-display-mixin";
import paginationMixin from "@/components/common/mini-table/mixins/pagination-mixin";
import CustomizeFieldsWithBtn from "@/components/common/mini-table/cells/CustomizeFieldsWithBtn.vue";
import LayoutConfigurationTitle from "@/components/common/mini-table/cells/LayoutConfigurationTitle.vue";
import gatherViewConfigMixin from "@/components/common/mini-table/mixins/gather-view-config-mixin";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import DeleteButton from "@/components/common/buttons/DeleteButton.vue";
import rowFormatMixin from "@/components/common/mini-table/mixins/row-format-mixin";
import EllipsisText from "@/components/common/mini-table/cells/EllipsisText.vue";
import ViewImages from "@/components/common/mini-table/cells/ViewImages.vue";

export default {
    name: "MiniTable",
    components: {
        ViewImages,
        EllipsisText,
        DeleteButton,
        MiniButton,
        LayoutConfigurationTitle,
        CustomizeFieldsWithBtn,
        TableChartConfigure,
        SortFilterDropdown,
        WheelNumber, DiverseInput, DiverseInputGroup, EmButton, EmptyListInfo, ReBModal
    },
    mixins: [selfCrudMixin, tableTreeMixin, rowGroupMixin, customDisplayMixin, paginationMixin, gatherViewConfigMixin, rowFormatMixin],
    props: {
        hideCustomizeFieldButton: {
            type: Boolean,
            default: false
        },
        headerTitle: {
            type: String,
            default: null
        },
        disableHeader: {
            type: Boolean,
            default: false
        },
        enableChartGenerator: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        showCustomizeFieldButton() {
            return (this.modelFieldsAvailable || this.entityName) && !this.hideCustomizeFieldButton;
        },
        showEmptyInfo() {
            return this.rowList.length === 0 && !this.tableLoading;
        },
        finalRowList() {
            // if (this.frozenRows) {
            //     return this.frozenRows;
            // }
            if (this.changeFlag) {
                //refresh
            }
            let result = [];
            //table tree
            if (this.tableTreeValid) {
                if (this.changeFlag) {
                    //refresh
                }
                let tempList = [];
                this.backtraceTreeRowList(tempList, this.headerRows);
                result = tempList;
            } else {
                result = this.rowListCover;
            }
            result = this.filterRows(result);
            result = this.doSort(result);
            result = this.groupRows(result);
            return result;
        },
    },
    watch: {
        items() {
            this.initData();
            this.$forceUpdate();
        },
        fields() {
            this.initData();
        },
    },
    created() {
        this.initData();
    },
    beforeDestroy() {
        this.$emit('disable');
    },
    methods: {
        initData() {
            if (this.items) {
                this.rowList = this.effectOriginRow ? this.items : this.deepCopy(this.items);
                this.generateTreeFailed = false;
                if (this.tableTreeValid) {
                    this.generateTreeStructure();
                }
            }
            this.formatRowByFieldConfig();
            this.initCustomVuexFields();
            this.initInputConfigList();
            //赋值fieldsMap
            this.setFieldsMap();
            this.clearRowEdit();
        },
        cellText(data) {
            let field = data.field;
            if (this.mutativeFieldType(data) === 'select') {
                if (field.optionsFromDict) {
                    return this._translateDict(field.optionsFromDict, data.value);
                }
                if (this.$store.state.dictionaryEnumStore.reloadFlag) {
                    //
                }
                if (field.options) {
                    for (let option of field.options) {
                        if (option.value === data.value || option.value === data.value + '') {
                            return option.text;
                        }
                    }
                }
            }
            let value = data.value;
            //format
            let formatter = data.field.valueFormatter;
            if (formatter && formatter instanceof Function) {
                value = formatter(value);
            }
            return value;
        },
        toggleSelect() {
            if (this.readOnly || this.enableOriginField) {
                return;
            }
            if (this.isSelectAll) {
                this.$refs.miniTable.clearSelected();
            } else {
                this.$refs.miniTable.selectAllRows();
            }
        },
        //when table row is clicked
        whenRowClick(item, index) {
            this.$emit('rowClick', item, index);
            if (this.rowClickCheck) {
                this.handleRowCheckEvent(item, !this.checkedIds.has(item[this.rowKey]));
            }
        },
        whenHeadDbClick(column) {
            if (this.filterable) {
                if (this.isActionColumn(column)) {
                    return;
                }
                if (this.openSortFilter.has(column)) {
                    this.clearColFilter(column);
                } else {
                    this.openSortFilter.add(column);
                }
                this.configChangeFlag++;
                this.$forceUpdate();
            }
        },
        clearColFilter(column) {
            this.openSortFilter.delete(column);
            this.removeFilter(column);
            this.clearIfSort(column);
            this.clearIfGroup(column);
        },
        openTableChart() {
            if (this.enableChartGenerator) {
                this.$refs.tableChartConfigureModal.showModal();
                let rows = this.deepCopyObj(this.finalRowList);
                rows = _.filter(rows, o => !o._isGroupTag);
                for (let field of this.fieldList) {
                    if (field.type === 'select' && field.options) {
                        for (let row of rows) {
                            let value = row[field.key];
                            row[field.key] = _.find(field.options, o => o.value === value || o.value === value + '');
                        }
                    }
                }
                let fields = this.deepCopy(this.localFields);
                this.$nextTick(() => this.$refs.tableChartConfigure.initializeData(
                    fields, rows, this.entityName))
            }
        },
        //----check----
        initCheckStatus(ids) {
            let idSet = new Set(ids);
            for (let row of this.getRowList()) {
                if (idSet.has(row[this.rowKey])) {
                    if (this.tableTreeValid && this.enableTreeCheck) {
                        this.changeTreeCheckStatus(row, true);
                    } else if (this.enableRowCheck) {
                        this.changeRowCheckStatus(row, true);
                    }
                }
            }
        },
        handleCheckAllEvent() {
            if (!this.isSelectAll) {
                // if (this.isSelectPart) {
                //     this.forceRefreshCheckView();
                // }
                for (let row of this.finalRowList) {
                    this.changeRowCheckStatus(row, true);
                }
            } else {
                for (let row of this.finalRowList) {
                    this.changeRowCheckStatus(row, false);
                }
            }
            this.emitCheckEvent();
            this.$nextTick(() => this.$forceUpdate());
        },
        // forceRefreshCheckView() {
        //     this.checkForceLoad = false;
        //     this.$nextTick(() => {
        //         this.checkForceLoad = true;
        //         this.$emit('checkForceLoaded');
        //     });
        // },
        fieldIsLink(field) {
            return field.isLink === true;
        },
        whenLinkClick(data) {
            this.$emit('linkClick', {
                key: data.field.key,
                row: data.item
            });
        },
    }
}
</script>

<style scoped>
.table-cover {
    margin-bottom: 0 !important;
    max-height: 100% !important;
}

.table-cover >>> table {
    width: max-content !important;
    min-width: 100% !important;
}

.table-cover >>> table thead tr {
    white-space: nowrap;
}

.table-cover >>> table thead tr th {
    overflow: auto;
}

.table-cover >>> table thead tr th:hover {
    resize: horizontal;
}

.mini-table-di-input-cover {
    min-width: 60px !important;
    max-width: 300px !important;
    width: 100%;
}

.action-column-header {
    color: #1a69dd;
}

.per-page-select-width {
    width: 70px !important;
    margin: auto 0.25rem auto auto;
}

.text-ellipsis {
    width: 150px !important;
}
</style>
